import React, { Component } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  CardTitle,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Media,
  Table,
} from "reactstrap";
import { Link } from "react-router-dom";

//import Charts
import StackedColumnChart from "./StackedColumnChart";

import modalimage1 from "../../assets/images/product/img-7.png";
import modalimage2 from "../../assets/images/product/img-4.png";

// Pages Components
import WelcomeComp from "./WelcomeComp";
import MonthlyEarning from "./MonthlyEarning";
import SocialSource from "./SocialSource";
import ActivityComp from "./ActivityComp";
import TopCities from "./TopCities";
import LatestTranaction from "./LatestTranaction";
import PostApiCall from "../../Api";
import GetApiCall from "../../GETAPI";
import Notiflix from "notiflix";
import moment from "moment";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withNamespaces } from "react-i18next";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      TotalAmount: 0,
      TotalCollection: 0,
      TotalCount: 0,
      Total_Amount: 0,
      TotalCustomerCounts: 0,
      Usertype: null
    };
  }

  componentDidMount() {
    Notiflix.Loading.Init({
      svgColor: "rgb(171, 61, 0)",
    });

    var login = localStorage.getItem("LoginDetail");
    var details = JSON.parse(login);
    // console.log(details[0])
    this.setState({
      Usertype: details[0].fld_usertype,
    });
    console.log("this.state.Usertype  " + this.state.Usertype )
    if (details[0].fld_usertype != "Admin")
    {
      window.location.href = "/"
    }
    
    Notiflix.Loading.Dots("");
    
    GetApiCall.getRequest("Get_TodayMonthcount").then((resultdes) =>
      resultdes.json().then((obj) => {
        //   console.log(obj.data)

        this.setState({
          Count: obj.data,
        });
        if (obj.data) {
          var newArr = [...obj.data];
          newArr.map((item) => {
            this.setState({
              TotalAmount: item.total_amount,
              TotalCollection: item.total_count,
            });
          });
        }

        Notiflix.Loading.Remove();
      })
    );

    // ===thismonthcollection===
    GetApiCall.getRequest("Get_Thismonthcollection").then((resultdes) =>
      resultdes.json().then((obj2) => {
        //   console.log(obj2.data)
        this.setState({
          Count1: obj2.data,
        });
        if (obj2.data) {
          var newArr = [...obj2.data];
          newArr.map((item) => {
            this.setState({
              TotalCount: item.total_Count,
            });
          });
        }

        Notiflix.Loading.Remove();
      })
    );

    // =========thismonthamount=========

    GetApiCall.getRequest("Get_Thismonthamount").then((resultdes) =>
      resultdes.json().then((obj3) => {
        this.setState({
          Count3: obj3.data,
        });
        if (obj3.data) {
          var newArr = [...obj3.data];
          newArr.map((item) => {
            this.setState({
              Total_Amount: item.total_amount,
            });
          });
        }

        Notiflix.Loading.Remove();
      })
    );

    // =========Customer Count=======

    GetApiCall.getRequest("Get_CustomerCount").then((resultdes) =>
      resultdes.json().then((obj5) => {
        this.setState({
          TotalCustomerCount: obj5.data,
        });
        if (obj5.data) {
          obj5.data.map((item) => {
            this.setState({
              TotalCustomerCounts: item.TotalCustomer,
            });
          });
        }

        Notiflix.Loading.Remove();
      })
    );
  }

  render() {
    // console.log(moment().format('ll'))
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumb */} 
            <Breadcrumbs
              title={this.props.t("Shanthi Jewellers")}
              breadcrumbItem={this.props.t("Dashboard")}
            />

            <Row>
              <Col xl="4">
                <WelcomeComp />
                {/* <MonthlyEarning/> */}
              </Col>
              <Col xl="8">
                <Row>
                  <Col md="12">
                    <Card>
                      <div
                        className="maxXchange-bg-soft-pink"
                        style={{
                          backgroundColor: " #ab3d00",
                          marginBottom: "-14px",
                          height: "46px",
                        }}
                      >
                        <Row>
                          <Col xs="6">
                            <div className="maxXchange-text p-3">
                              <h5 className="maxXchange-text">Menu</h5>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Card>
                  </Col>
                  {/* Reports Render */}
                  <Col md="3">
                    <Card className="mini-stats-wid">
                      <CardBody>
                        <Media>
                          <Media body>
                            <a href="/transaction_list">
                              
                              <p className="text-muted font-weight-medium">
                                Transactions
                              </p>
                            </a>
                            <hr />
                            <a href="/approve_client">
                              
                              <p className="text-muted font-weight-medium">
                                Approve Client
                              </p>
                            </a>
                          </Media>
                        </Media>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col md="3">
                    <Card className="mini-stats-wid">
                      <CardBody>
                        <Media>
                          <Media body>
                            <a href="/add_new_client">
                              
                              <p className="text-muted font-weight-medium">
                                Add New Client
                              </p>
                            </a>
                            <hr />
                            <a href="/view_client">
                              
                              <p className="text-muted font-weight-medium">
                                View Client
                              </p>
                            </a>
                          </Media>
                        </Media>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col md="3">
                    <Card className="mini-stats-wid">
                      <CardBody>
                        <Media>
                          <Media body>
                            <a href="/offline_payment">
                              <p className="text-muted font-weight-medium">
                                Payment
                              </p>
                            </a>
                            <hr />
                            <a href="/offline_acknowledgement">
                              
                              <p className="text-muted font-weight-medium">
                                Acknowledgement
                              </p>
                            </a>
                          </Media>
                        </Media>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col md="3">
                    <Card className="mini-stats-wid">
                      <CardBody>
                        <Media>
                          <Media body>
                            <a href="/close_account">
                              <p className="text-muted font-weight-medium">
                                Close Account
                              </p>
                            </a>
                            <hr />
                            <a href="/close_account_list">
                              
                              <p className="text-muted font-weight-medium">
                                Close Account List
                              </p>
                            </a>
                          </Media>
                        </Media>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row>
              <Col xl="4">
                {/* <WelcomeComp /> */}
                <MonthlyEarning />
              </Col>

              <Col xl="8">
                <Row>
                  {/* Reports Render */}
                  <Col md="4">
                    <Card className="mini-stats-wid">
                      <CardBody>
                        <Media>
                          <Media body>
                            <h4 className="mb-0">Customers</h4>
                            <hr />
                            <p className="text-muted font-weight-medium">
                              Total Customer
                              <span className="text-muted font-weight-medium float-right">
                                {this.state.TotalCustomerCounts}
                              </span>
                            </p>
                            <hr />
                            <p className="text-muted font-weight-medium">
                              This Month Customer
                              <span className="text-muted font-weight-medium float-right">
                                11
                              </span>
                            </p>
                          </Media>
                        </Media>
                      </CardBody>
                    </Card>
                  </Col>

                  <Col md="4">
                    <Card className="mini-stats-wid">
                      <CardBody>
                        <Media>
                          <Media body>
                            <h4 className="mb-0">Today's Collection</h4>
                            <hr />
                            <p className="text-muted font-weight-medium">
                              Total Collection
                              <span className="text-muted font-weight-medium float-right">
                                {this.state.TotalCollection}
                              </span>
                            </p>
                            <hr />
                            <p className="text-muted font-weight-medium">
                              Total Amount
                              <span className="text-muted font-weight-medium float-right">
                                {this.state.TotalAmount !== null
                                  ? this.state.TotalAmount
                                  : 0}
                              </span>
                            </p>
                          </Media>
                        </Media>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col md="4">
                    <Card className="mini-stats-wid">
                      <CardBody>
                        <Media>
                          <Media body>
                            <h4 className="mb-0">This Month's Collection</h4>
                            <hr />
                            <p className="text-muted font-weight-medium">
                              Total Collection
                              <span className="text-muted font-weight-medium float-right">
                                {this.state.TotalCount}
                              </span>
                            </p>
                            <hr />
                            <p className="text-muted font-weight-medium">
                              Total Amount
                              <span className="text-muted font-weight-medium float-right">
                                {this.state.Total_Amount}
                              </span>
                            </p>
                          </Media>
                        </Media>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row>
              <Col lg="12">
                <LatestTranaction />
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withNamespaces()(Dashboard);
